/**
 * Blocks /v2/demo/:id when Host tenant has not enabled that demo id.
 * Platform apex always passes.
 */
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Alert, Box, Button, CircularProgress, Container, Typography } from '@mui/material';
import usePublicHybridDemos from '../../hooks/usePublicHybridDemos';

export default function HybridDemoGate({ demoId, children }) {
  const { loading, enabled, demos, source, isDemoEnabled, defaultDemoId } = usePublicHybridDemos();

  if (loading) {
    return (
      <Box sx={{ minHeight: '40vh', display: 'grid', placeItems: 'center' }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  // Platform marketing host — always allow known demos
  if (source === 'platform_apex' || isDemoEnabled(demoId)) {
    return children;
  }

  const fallback = demos.find((d) => d.id === defaultDemoId) || demos[0];

  return (
    <Container sx={{ py: 8, maxWidth: 560 }} data-testid="hybrid-demo-disabled">
      <Alert severity="info" sx={{ mb: 2 }}>
        This demo is not enabled for this site.
        {!enabled
          ? ' Ask your admin to turn on hybrid demos in Tenant Management → Public experiences.'
          : ` Enabled demos: ${(demos || []).map((d) => d.title || d.id).join(', ') || 'none'}.`}
      </Alert>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Demo id: <code>{demoId}</code>
      </Typography>
      <StackButtons fallback={fallback} />
    </Container>
  );
}

function StackButtons({ fallback }) {
  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      {fallback?.path ? (
        <Button component={RouterLink} to={fallback.path} variant="contained" sx={{ textTransform: 'none' }}>
          Go to {fallback.title || fallback.id}
        </Button>
      ) : null}
      <Button component={RouterLink} to="/" variant="outlined" sx={{ textTransform: 'none' }}>
        Home
      </Button>
    </Box>
  );
}
